import { X, Trash2 } from 'lucide-react';
import { Button } from '@/features/ui/components/Button';

interface DeleteMappingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  mappingName: string;
}

const DeleteMappingModal = ({
  isOpen,
  onClose,
  onConfirm,
  mappingName,
}: DeleteMappingModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center text-red-600">
            <Trash2 className="h-6 w-6 mr-2" />
            <h2 className="text-xl font-bold text-gray-900">Delete Mapping</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <X className="h-6 w-6" />
          </button>
        </div>
        <p className="text-gray-700 mb-6">
          Are you sure you want to delete the mapping{' '}
          <span className="font-semibold">{mappingName}</span>? This action cannot be undone.
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="destructive" onClick={onConfirm}>
            Delete
          </Button>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMappingModal;
